import React from 'react';
import {connect} from 'react-redux';
import Modal from './Modal';
import {
    moveExcursionToBookableInCart, moveExcursionToWaitlistInCart,
    removeExcursionFromCart, removeNotBookableEntriesFromCart,
} from '../actions/cartActions';
import {getCartErrorModalButtonText, getCartErrorModalHeaderText, getExcursionConflictGroupText} from "../utils/themeUtils";
import ActionButton from "./ActionButton";
import ModalFooter from "./ModalFooter";
import { Trans, useLingui } from '@lingui/react/macro';

function CartErrorModal({ notBookableExcursions, notBookableTac }) {
    const notBookableExcursionsGroups = Object.keys(notBookableExcursions);
    const { t } = useLingui();

    return (
        <Modal
            show={notBookableExcursionsGroups.length > 0 || notBookableTac.length > 0}
            onClose={() => {}}
            title={t({id: "action_required"})}
            removeDissmissButton={true}
        >
            <div className="flex grow flex-col">
                <div className="grow bg-white py-4 px-2 sm:px-4">
                    <div className="text-xl mb-4">
                        {getCartErrorModalHeaderText()}
                    </div>
                    <div className="my-2">
                        {notBookableExcursionsGroups.map((group) =>
                            <ExcursionConflictGroup key={group} group={group} excursions={notBookableExcursions[group]} />
                        )}

                        {notBookableTac.map((tacEntry) =>
                            <div key={tacEntry.id}>
                                <div className="my-4">
                                    <div className="text-primary-dark text-lg">{tacEntry.name}</div>
                                    <div>
                                        <Trans id="reservation_at">
                                            Reservation at {tacEntry.time}
                                        </Trans>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
                <ModalFooter
                    actionDisabled={false}
                    actionButtonText={getCartErrorModalButtonText()}
                    onActionClick={removeNotBookableEntriesFromCart}
                />
            </div>
        </Modal>
    )
}

function mapStateToProps(state) {
    return {
        notBookableExcursions: state.cart?.notBookableEntries?.excursions || {},
        notBookableTac: state.cart?.notBookableEntries?.tac || [],
    }
}

export default connect(mapStateToProps)(CartErrorModal);

function ExcursionConflictGroup({excursions, group}) {
    return (
        <div>
            <div className="my-4">
                {getExcursionConflictGroupText(group)}
            </div>
            <div>
                {excursions.map((excursion) =>
                    <ExcursionConflict key={excursion.excursionId} excursion={excursion} />
                )}
            </div>
        </div>
    )
}



function ExcursionConflict({excursion}) {
    const {t} = useLingui();
    return (
        <div className="border-b">
            <div className="my-4">
                <div className="text-primary-dark text-lg">{excursion.excursionName}</div>

                <div>
                    {excursion.passengers.map((passenger) =>
                        <div key={passenger.id}>
                            {`${passenger.firstName} ${passenger.lastName}`}
                        </div>
                    )}
                </div>

                {/* When status is SoldOut it needs to be removed since it can not be booked or waidlisted */}
                { excursion.status === "SoldOut" &&
                <div className="my-2 text-right">
                    <ActionButton
                        onClick={() => removeExcursionFromCart(excursion.itineraryId, excursion.excursionId)}
                        buttonText={t({id: "remove_from_planner"})}
                    />
                </div>
                }


                {/* When status is Bookable it can be moved to booking state or be removed */}
                { excursion.status === "Bookable" &&
                <div className="my-2 flex justify-between">
                    <ActionButton
                        onClick={() => moveExcursionToBookableInCart(excursion.itineraryId, excursion.excursionId)}
                        buttonText={t({id: "add_to_planner"})}
                    />
                    <ActionButton
                        onClick={() => removeExcursionFromCart(excursion.itineraryId, excursion.excursionId)}
                        buttonText={t({id: "remove_from_planner"})}
                    />
                </div>
                }


                {/* When status is Waitlist it can be moved to waitlist state or be removed */}
                { excursion.status === "Waitlisted" &&
                <div className="my-2 flex justify-between">
                    <ActionButton
                        onClick={() => moveExcursionToWaitlistInCart(excursion.itineraryId, excursion.excursionId)}
                        buttonText={t({id: "waitlist_add_cta"})}
                    />
                    <ActionButton
                        onClick={() => removeExcursionFromCart(excursion.itineraryId, excursion.excursionId)}
                        buttonText={t({id: "remove_from_planner"})}
                    />
                </div>
                }

                {/* When status is none of the above it needs to be removed since we don't know what it is */}
                {/* TODO - if the list of statuses grows update this as well and/or make it more generic/extract to own component*/}
                { excursion.status !== "SoldOut" &&
                excursion.status !== "Bookable" &&
                excursion.status !== "Waitlisted" &&
                <div className="my-2 text-right">
                    <ActionButton
                        onClick={() => removeExcursionFromCart(excursion.itineraryId, excursion.excursionId)}
                        buttonText={t({id: "remove_from_planner"})}
                    />
                </div>
                }
            </div>

        </div>
    )
}